import { render, staticRenderFns } from "./card-sona.vue?vue&type=template&id=5ddf4372&scoped=true&"
import script from "./card-sona.vue?vue&type=script&lang=js&"
export * from "./card-sona.vue?vue&type=script&lang=js&"
import style0 from "./card-sona.vue?vue&type=style&index=0&id=5ddf4372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf4372",
  null
  
)

export default component.exports